const offerings = [
  {
    icon: "ri-scissors-cut-line",
    title: "Stainless Steel Worktops & Counters",
    desc: "Custom-fabricated work surfaces with upstands, sinks, and splash backs — precision-cut to fit any kitchen layout.",
    image: "/images/kitchen/worktops.webp",
  },
  {
    icon: "ri-settings-4-line",
    title: "Extraction Hoods & Canopies",
    desc: "High-performance ventilation canopies and extraction hoods for grease, steam, and smoke removal — engineered for efficiency.",
    image: "/images/kitchen/extraction-hood.webp",
  },
  {
    icon: "ri-archive-line",
    title: "Shelving & Storage Units",
    desc: "Wall-mounted, mobile, and freestanding stainless steel shelving systems for refrigerated or ambient food storage.",
    image: "/images/kitchen/shelving.webp",
  },
  {
    icon: "ri-restaurant-line",
    title: "Cooking Ranges & Stations",
    desc: "Custom cooking line assemblies including prep stations, hot stations, and pass-through service counters.",
    image: "/images/kitchen/cooking-range.webp",
  },
  {
    icon: "ri-drop-line",
    title: "Sinks & Wash Stations",
    desc: "Single, double, and triple-bowl sinks with integrated draining boards, grease traps, and hygienic waste systems.",
    image: "/images/kitchen/sinks.webp",
  },
  {
    icon: "ri-temp-cold-line",
    title: "Refrigeration Counters & Cold Rooms",
    desc: "Fabricated refrigeration counters and walk-in cold room paneling built for long-term food preservation at commercial scale.",
    image: "/images/kitchen/refrigeration.webp",
  },
];

export default function KitchenOfferings() {
  return (
    <section id="offerings" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">What We Fabricate</span>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight">
            Our Product Range
          </h2>
          <p className="text-gray-500 text-sm mt-4 max-w-xl mx-auto leading-relaxed">
            Every item we produce is fabricated in-house from commercial-grade stainless steel and tailored precisely to your kitchen&apos;s dimensions and operational needs.
          </p>
        </div>

        {/* Products grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {offerings.map((item, i) => (
            <div key={i} className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-teal-200 transition-all duration-300 group">
              <div className="relative overflow-hidden h-52">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center bg-teal-600 rounded-lg">
                  <i className={`${item.icon} text-base text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-gray-900 font-bold text-sm uppercase tracking-wide mb-2">{item.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                <a
                  href="#inquiry"
                  onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
                  className="mt-4 inline-flex items-center gap-1.5 text-teal-600 hover:text-teal-700 text-xs font-semibold uppercase tracking-wider cursor-pointer transition-colors"
                >
                  Enquire Now
                  <i className="ri-arrow-right-line text-sm"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
